import {
    CREATE_YARN_PO_FAILURE,
    CREATE_YARN_PO_REQUEST,
    CREATE_YARN_PO_SUCCESS,
    CREATE_USER_FORM_YARN_PO,
    FETCH_SINGLE_YARN_PO_FAILURE,
    FETCH_SINGLE_YARN_PO_REQUEST,
    FETCH_SINGLE_YARN_PO_SUCCESS,
    FETCH_YARN_PO_FAILURE,
    FETCH_YARN_PO_REQUEST,
    FETCH_YARN_PO_SUCCESS,
    NAVIGATE_YARN_PO_DETAILS,
    NAVIGATE_YARN_PO,
    YARN_PO_USERFORM_RESET,
    UPDATE_YARN_PO_FAILURE,
    UPDATE_YARN_PO_REQUEST,
    UPDATE_YARN_PO_SUCCESS,
    DELETE_YARN_PO_REQUEST,
    DELETE_YARN_PO_SUCCESS,
    DELETE_YARN_PO_FAILURE,
    FETCH_YARN_PO_SECTION_LIST_REQUEST,
    FETCH_YARN_PO_SECTION_LIST_SUCCESS,
    FETCH_YARN_PO_SECTION_LIST_FAILURE,
    FETCH_YARN_PO_PROGRAM_LIST_REQUEST,
    FETCH_YARN_PO_PROGRAM_LIST_SUCCESS,
    FETCH_YARN_PO_PROGRAM_LIST_FAILURE,
    FETCH_YARN_PO_SALES_ORDER_REQUEST,
    FETCH_YARN_PO_SALES_ORDER_SUCCESS,
    FETCH_YARN_PO_SALES_ORDER_FAILURE,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE,
    FETCH_YARN_PO_WITHOUT_FILTER_REQUEST,
    FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS,
    FETCH_YARN_PO_WITHOUT_FILTER_FAILURE,
    YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_YARN_PO_INVOICE_REQUEST,
    FETCH_YARN_PO_INVOICE_SUCCESS,
    FETCH_YARN_PO_INVOICE_FAILURE,
    RESET_YARN_PO_INVOICE,
    FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS,
    FETCH_YARN_PO_UNIT_LIST_SUCCESS,
    FETCH_YARN_PO_UNIT_LIST_REQUEST,
    FETCH_YARN_PO_SUPPLIER_LIST_REQUEST,
    FETCH_YARN_PO_UNIT_LIST_FAILURE,
    FETCH_YARN_PO_SUPPLIER_LIST_FAILURE,
    FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST,
    FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS,
    FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE,
    FETCH_YARN_LOTNO_INVOICE_REQUEST,
    FETCH_YARN_LOTNO_INVOICE_SUCCESS,
    FETCH_YARN_LOTNO_INVOICE_FAILURE,
    FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST,
    FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS,
    FETCH_YARN_PO_PENDING_SUPPLIER_LIST_REQUEST,
    FETCH_YARN_PO_PENDING_SUPPLIER_LIST_SUCCESS,
    FETCH_YARN_PO_PENDING_SUPPLIER_LIST_FAILURE,
    FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_REQUEST,
    FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_SUCCESS,
    FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_FAILURE,
    SET_UNIT_NAME_YARN_PO,
    DELETE_BTN_UPDATE_API_REQUEST,
    DELETE_BTN_UPDATE_API_FAILURE,
    SET_GRID_PAGE_INDEX_YARN_PO,
    OTP_API_POST_CLOSE_CALL_REQUEST,
    OTP_API_POST_CLOSE_CALL_SUCCESS,
    OTP_API_POST_CLOSE_CALL_FAILURE,
    OTP_API_POST_CLOSE_ALL_CALL_REQUEST,
    OTP_API_POST_CLOSE_ALL_CALL_FAILURE,
    OTP_API_POST_CLOSE_ALL_CALL_SUCCESS,
    CREATE_USER_FORM_PROGRAM_WISE_REPORT,
    FETCH_READYGARMENT_PO_SALES_ORDER_REQUEST,
    FETCH_READYGARMENT_PO_SALES_ORDER_SUCCESS,
    FETCH_READYGARMENT_PO_SALES_ORDER_FAILURE,
    HEADER_SEARCH_CALL_ONLOAD,
    EDIT_API_SELECTED_ROWS_CALL_SUCCESS,
    EDIT_API_SELECTED_ROWS_CALL_REQUEST,
    EDIT_API_SELECTED_ROWS_CALL_FAILURE,
    PROGRAM_WISE_REPORT_RESET,
    NAVIGATE_YARN_PO_PRINT,
} from './yarnPO.actionsType';

export const YARN_PO = 'yarnPO';

let initialState = {
    loading: false,
    gridPageIndex: 0,
    yarnPO: [],
    yarnPoInvoiceV2: [],
    yarnLotNoInvoice: [],
    sectionList: [],
    programList: [],
    deliveryList: [],
    yarnPOUnitList: [],
    yarnPoWithoutFilter: [],
    pendingYarnSupplierList: [],
    styleNumberList: [],
    salesOrderList: [],
    salesOrderReadyGarments: [],
    pendingYarnDeliveryAtList: [],
    supplierList: [],
    supplierListBasedOnProgram: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        FldIsGenerateStyleWise: false,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    
    editSelectedRows: [],
    detailsId: '',
    unitId: 1,
    activeKey: 1,
    isYarnPO: false,
    yarnPOSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    otp: '',
    closeAllOtp: '',
    headerSearchCall: true,
    programWiseUserform: {
        fldFKUnitId: '',
        fldFKProgramId: '',
        fldFKFilterId: 'DCDate',
        programName: '',
        searchText: '',
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date()
    },
    printPageStatusChecker: []
};

export let yarnPOReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === FETCH_YARN_PO_INVOICE_SUCCESS) {
        localStorage.setItem('invoiceYarn', JSON.stringify(updatePayload));
    }


    console.log('state!@!!', state)
    switch (type) {
        case FETCH_YARN_PO_REQUEST:
        case FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST:
        case CREATE_YARN_PO_REQUEST:
        case FETCH_SINGLE_YARN_PO_REQUEST:
        case UPDATE_YARN_PO_REQUEST:
        case DELETE_YARN_PO_REQUEST:
        case FETCH_YARN_PO_SECTION_LIST_REQUEST:
        case FETCH_YARN_PO_PROGRAM_LIST_REQUEST:
        case FETCH_YARN_PO_SALES_ORDER_REQUEST:
        case FETCH_YARN_PO_WITHOUT_FILTER_REQUEST:
        case FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST:
        case FETCH_YARN_PO_INVOICE_REQUEST:
        case FETCH_YARN_PO_UNIT_LIST_REQUEST:
        case FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_REQUEST:
        case FETCH_YARN_PO_SUPPLIER_LIST_REQUEST:
        case FETCH_YARN_PO_PENDING_SUPPLIER_LIST_REQUEST:
        case FETCH_YARN_LOTNO_INVOICE_REQUEST:
        case FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST:
        case DELETE_BTN_UPDATE_API_REQUEST:
        case OTP_API_POST_CLOSE_CALL_REQUEST:
        case OTP_API_POST_CLOSE_ALL_CALL_REQUEST:
        case FETCH_READYGARMENT_PO_SALES_ORDER_REQUEST:
        case EDIT_API_SELECTED_ROWS_CALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPO: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case EDIT_API_SELECTED_ROWS_CALL_SUCCESS:
            return {
                ...state,
                loading: false,
                editSelectedRows: updatePayload
            }
        case FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierListBasedOnProgram: updatePayload
            };

        // printPageStatusChecker
        case CREATE_USER_FORM_PROGRAM_WISE_REPORT:
            return {
                ...state,
                loading: false,
                programWiseUserform: {
                    ...state.programWiseUserform,
                    [payload.key]: payload.value
                }
            }
        case PROGRAM_WISE_REPORT_RESET:
            return {
                ...state,
                programWiseUserform: {
                    fldFKUnitId: '',
                    fldFKProgramId: '',
                    fldFKFilterId: 'DCDate',
                    programName: '',
                    searchText: '',
                    startDate: new Date().setDate(new Date().getDate() - 15),
                    endDate: new Date()
                }
            }
        case FETCH_YARN_PO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPoInvoiceV2: updatePayload,

            };

        case FETCH_YARN_PO_PENDING_SUPPLIER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingYarnSupplierList: updatePayload?.YAI
            };
        case FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingYarnDeliveryAtList: updatePayload
            };
        case OTP_API_POST_CLOSE_ALL_CALL_SUCCESS:
            return {
                ...state,
                loading: false,
                closeAllOtp: updatePayload
            };
        case FETCH_YARN_LOTNO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnLotNoInvoice: updatePayload
            };
        case FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPoWithoutFilter: updatePayload
            };
        case FETCH_YARN_PO_SECTION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                sectionList: updatePayload
            };
        case OTP_API_POST_CLOSE_CALL_SUCCESS:
            return {
                ...state,
                loading: false,
                otp: updatePayload
            };
        case FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierList: updatePayload
            };
        case FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryList: updatePayload
            };
        case FETCH_YARN_PO_UNIT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPOUnitList: updatePayload
            };
        case CREATE_YARN_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_YARN_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case UPDATE_YARN_PO_SUCCESS:
            return {
                ...state,
                loading: false,

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case DELETE_YARN_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false
                },
                detailsId: ''
            };
        case FETCH_YARN_PO_PROGRAM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                programList: updatePayload
            };
        case FETCH_YARN_PO_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderList: updatePayload
            };
        case FETCH_READYGARMENT_PO_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderReadyGarments: updatePayload
            }
        case FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                styleNumberList: updatePayload
            };
        case FETCH_YARN_PO_FAILURE:
        case FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE:
        case FETCH_YARN_PO_INVOICE_FAILURE:
        case FETCH_SINGLE_YARN_PO_FAILURE:
        case FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_FAILURE:
        case FETCH_YARN_PO_PENDING_SUPPLIER_LIST_FAILURE:
        case CREATE_YARN_PO_FAILURE:
        case UPDATE_YARN_PO_FAILURE:
        case DELETE_YARN_PO_FAILURE:
        case FETCH_YARN_PO_SECTION_LIST_FAILURE:
        case FETCH_YARN_PO_PROGRAM_LIST_FAILURE:
        case FETCH_YARN_PO_SALES_ORDER_FAILURE:
        case FETCH_YARN_PO_WITHOUT_FILTER_FAILURE:
        case FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE:
        case FETCH_YARN_PO_UNIT_LIST_FAILURE:
        case FETCH_YARN_PO_SUPPLIER_LIST_FAILURE:
        case FETCH_YARN_LOTNO_INVOICE_FAILURE:
        case DELETE_BTN_UPDATE_API_FAILURE:
        case OTP_API_POST_CLOSE_CALL_FAILURE:
        case OTP_API_POST_CLOSE_ALL_CALL_FAILURE:
        case FETCH_READYGARMENT_PO_SALES_ORDER_FAILURE:
        case EDIT_API_SELECTED_ROWS_CALL_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_PO:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
                headerFields: {
                    ...state.headerFields,
                    [payload.key]: payload.value
                }
            };


        case YARN_PO_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: '',
                activeKey: 1,
                // sectionList: [],
                // programList: [],
                styleNumberList: [],

            };
        case NAVIGATE_YARN_PO_DETAILS:
            return {
                ...state,
                isYarnPO: true,
                loading: false,
                yarnPOSelectedValue: updatePayload.yarnPOSelectedValue
            };
        case NAVIGATE_YARN_PO_PRINT:
            return {
                ...state,
                isYarnPO: false,
                loading: false,
                yarnPOSelectedValue: updatePayload.yarnPOSelectedValue
            }
        case SET_UNIT_NAME_YARN_PO:
            return {
                ...state,
                unitId: payload
            };
        case SET_GRID_PAGE_INDEX_YARN_PO:
            return {
                ...state,
                gridPageIndex: payload
            };
        case NAVIGATE_YARN_PO:
            return {
                ...state,
                isYarnPO: false
            };
        case RESET_YARN_PO_INVOICE:
            return {
                ...state,
                yarnPoInvoiceV2: []
            };
        case YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2,
                sectionList: [],
                programList: []
            };
        case YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                sectionList: [],
                programList: [],
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
